export const contentTableConfig = {
  title: '股票跟踪消息统计',
  propList: [
    { prop: 'sname', label: '账号', minWidth: '100', slotName: 'sname' },
    { prop: 'usedBy', label: '使用人', minWidth: '100' },
    {
      prop: 'deptName',
      label: '部门',
      minWidth: '100',
      slotName: 'deptName'
    },
    {
      prop: 'uname',
      label: '接收人',
      minWidth: '100',
      slotName: 'uname'
    },
    {
      prop: 'msgTimeStr',
      label: '时间',
      sortable: true,
      minWidth: '100'
    },
    {
      prop: 'content',
      label: '内容',
      minWidth: '400',
      slotName: 'content'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
